document.addEventListener("DOMContentLoaded", function () {
  function updateBagPrice() {
    var subPriceEl = document.querySelector(
      ".appstle_subscription_final_price"
    );
    var bagPriceEl = document.getElementById("bag-price-subscription");
    if (!subPriceEl || !bagPriceEl) return;

    var priceText = subPriceEl.textContent.replace(/[^0-9.]/g, "");
    var basePrice = parseFloat(priceText);

    if (isNaN(basePrice)) {
      bagPriceEl.textContent = "";
      return;
    }

    var bagPrice = (basePrice * 5).toFixed(2);
    bagPriceEl.textContent = "$" + bagPrice + " for 5 lb bag (subscription)";
  }

  // Run on page load
  updateBagPrice();

  // Listen for Appstle's price update event
  document.addEventListener(
    "appstle_subscription_price_updated",
    updateBagPrice
  );

  // Optional: Also update on variant change
  document
    .querySelectorAll('input[name="id"], select[name="id"]')
    .forEach(function (input) {
      input.addEventListener("change", function () {
        setTimeout(updateBagPrice, 250); // Wait for price to update
      });
    });
});
